import { render, staticRenderFns } from "./seeHistory.vue?vue&type=template&id=f97b137a&scoped=true"
import script from "./seeHistory.vue?vue&type=script&lang=js"
export * from "./seeHistory.vue?vue&type=script&lang=js"
import style0 from "./seeHistory.vue?vue&type=style&index=0&id=f97b137a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97b137a",
  null
  
)

export default component.exports